/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sysconfig.vue?vue&type=template&id=1531b5bc&scoped=true"
import script from "./sysconfig.vue?vue&type=script&lang=js"
export * from "./sysconfig.vue?vue&type=script&lang=js"
import style0 from "./sysconfig.vue?vue&type=style&index=0&id=1531b5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531b5bc",
  null
  
)

export default component.exports